import React, { useRef, useEffect, useCallback } from 'react'
import { setMapConfigMode } from 'actions/livefeed/steerpathMapActions'
import './index.less'
var geoViewport = require('@mapbox/geo-viewport');

const SteerPathMap = (props) => {
    const { setLivefeedOptionsHandle, dispatch, mapApiKey, liveApiKey, mapConfig, mapConfigMode, slideCurrentIndex } = props

    const styleFile = mapConfig.use3dMap ? "default.json" : "default_simplified.json"
    const mapboxMap = useRef(null)
    const steerpathMap = useRef(null)
    const steerpathLive = useRef(null)
    const { center, zoom, bearing, pitch, hash, attributionControl,
        bearingSnap, buildingRef, layerIndex } = mapConfig

    // Map initialise
    useEffect(() => {
        // check mapConfigMode, No need to reload the map when dragend or zoomend event changes
        if (mapApiKey && mapConfigMode === "user_input") {
            console.log("initialise Map")
            const styleUrl = "https://mapdata.eu.steerpath.com/style/" + styleFile + "?access_token=" + mapApiKey
            mapboxMap.current = new mapboxgl.Map({
                container: 'mapboxMap',
                style: styleUrl,
                center: center, // [24.8123896, 60.2209478],
                zoom: zoom,
                bearing: bearing,
                pitch: pitch,
                hash: hash,
                attributionControl: attributionControl,
                bearingSnap: bearingSnap
            });
            if (mapboxMap.current) {
                steerpathMap.current = new steerpath.SteerpathMap(mapboxMap.current, mapApiKey) //create instance of SteerpathMap
                steerpathMap.current.setBuildingDefaultLayerIndex(buildingRef, layerIndex)
                const floorSwitcher = new steerpath.FloorSwitcherControl(steerpathMap.current)
                mapboxMap.current.addControl(floorSwitcher, 'bottom-left')
                mapboxMap.current.on("load", () => {
                    addLive()//once map is loaded init the live service
                });
                mapboxMap.current.on("moveend", () => {
                    console.log("moveend e ")
                    storeLatestMapView()
                })
                mapboxMap.current.on("steerpathLayerIndexChanged", () => {
                    console.log("start steerpathLayerIndexChanged e ")
                    storeLatestLayerIndexChanged()
                })
            }
        }
    },
        [
            addLive, attributionControl, bearing, bearingSnap, buildingRef, center, hash,
            mapApiKey, mapConfigMode, layerIndex, pitch, zoom, storeLatestMapView, slideCurrentIndex,
            storeLatestLayerIndexChanged, styleFile
        ]
    )
    // CLEAN UP
    // when slideCurrentIndex and mapApiKey changes, remove steerpathMap instance as well as steerpathMap and steerpathLive
    useEffect(() => {
        return (() => {
            if (mapboxMap.current) {
                console.log("remove moveend ")
                mapboxMap.current.off("moveend")
                console.log("remove steerpathLayerIndexChanged ")
                mapboxMap.current.off("steerpathLayerIndexChanged")

                console.log("steerpathLive stop live, empty steerpathMap instance, remove mapboxMap ")
                steerpathLive.current && steerpathLive.current.stopLive()
                mapboxMap.current && mapboxMap.current.remove()
                steerpathMap.current = null
            }
        })
    }, [mapApiKey, slideCurrentIndex])

    // getBounds when user_input mode is on
    useEffect(() => {
        if (mapConfigMode === "user_input") {
            const { lat, lng } = mapboxMap.current.getCenter()
            // get bounds based on geoViewport
            const { width, height } = mapboxMap.current.getCanvas().getBoundingClientRect();
            let boundsArr = geoViewport.bounds([lng, lat], mapboxMap.current.getZoom(), [width, height], 512)
            const bounds = [[boundsArr[0], boundsArr[1]], [boundsArr[2], boundsArr[3]]]
            let obj = {
                bounds: bounds
            }
            setLivefeedOptionsHandle("mapConfig", obj)
        }
    }, [mapConfig.center, mapConfig.zoom, mapConfigMode, setLivefeedOptionsHandle])

    // storeLatestMapView when map_interact mode is on
    const storeLatestMapView = useCallback(() => {
        const { lat, lng } = mapboxMap.current.getCenter()
        // get bounds based on geoViewport
        const { width, height } = mapboxMap.current.getCanvas().getBoundingClientRect();
        let boundsArr = geoViewport.bounds([lng, lat], mapboxMap.current.getZoom(), [width, height], 512)
        const bounds = [[boundsArr[0], boundsArr[1]], [boundsArr[2], boundsArr[3]]]
        let obj = {
            zoom: mapboxMap.current.getZoom().toFixed(4),
            center: [lng.toFixed(7), lat.toFixed(7)],
            bearing: mapboxMap.current.getBearing().toFixed(4),
            pitch: mapboxMap.current.getPitch().toFixed(4),
            bounds: bounds
        }
        setLivefeedOptionsHandle("mapConfig", obj)
        if (mapConfigMode === "user_input") {
            let mapConfigMode = "map_interact"
            dispatch(setMapConfigMode(mapConfigMode))
        }
    }, [dispatch, mapConfigMode, setLivefeedOptionsHandle])

    const storeLatestLayerIndexChanged = useCallback(() => {
        const latestLayerIndex = steerpathMap.current.getActiveBuildingLayerIndex()
        const latestBuildingRef = steerpathMap.current.getActiveBuildingBuildingRef()
        let obj = {
            buildingRef: latestBuildingRef,
            layerIndex: latestLayerIndex
        }
        setLivefeedOptionsHandle("mapConfig", obj)
        if (mapConfigMode === "user_input") {
            let mapConfigMode = "map_interact"
            dispatch(setMapConfigMode(mapConfigMode))
        }
    }, [dispatch, mapConfigMode, setLivefeedOptionsHandle])

    const addLive = useCallback(() => {
        if (mapApiKey) {
            //console.log("addLive")
            let liveUrls = {
                "defaultUrl": "https://live-eu3.steerpath.com/sdk-data"
            }
            if (liveApiKey) {
                let liveOptions = {
                    "apiKey": liveApiKey,
                    "interval": 2000, //milliseconds
                    "liveDataTitles": {},
                    "liveUrl": liveUrls.defaultUrl
                }
                steerpathLive.current = new steerpath.SteerpathLive(mapboxMap.current, liveOptions);
            }
        }
    }, [liveApiKey, mapApiKey])

    return (
        <div id='mapboxMap' >
            <div id="attribution">
                <a href="https://www.steerpath.com/" target="_blank" rel="noopener noreferrer">© Steerpath </a>
                <a href="https://www.maptiler.com/copyright/" target="_blank" rel="noopener noreferrer">© MapTiler</a>
                <a href="https://www.openstreetmap.org/copyright" target="_blank" rel="noopener noreferrer">© OpenStreetMap contributors</a>
            </div>
        </div>
    );
}

export default SteerPathMap;


// WEBPACK FOOTER //
// ./src/components/pages/livefeed/Editor/EditorContainer/LivefeedPreview/LeftPaneView/Floorplan/SteerPathMap/index.jsx